import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SJInvTerrainCom} from '../containers'
function SJInvTerrainComPage() {
    //we are inet so id is not passed
    console.log('SV*****SJInvTerrainComPage')
    let { id } = useParams();
    let svparams = { 'id': id}

    console.log('SV*****SJInvTerrainComPage',svparams)
    
    return (
        <SJInvTerrainCom svparams={svparams} ></SJInvTerrainCom>
        
    );
}
export default SJInvTerrainComPage